import { Button, Input, message } from 'antd';
import React, { Component } from 'react';
import '../../css/style.less';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';

const { TextArea } = Input;

export default class KeyAnalysis extends Component {
    state = {
        params: {},
        evaluateRecordId: '',
        quotationType: '',
        type: 'view',
        list: [],
    }

    componentDidMount(){
        const { evaluateRecordId, quotationType } = this.props;
        this.setState({
            evaluateRecordId,
            quotationType,
        },() => {
            this.loadData(evaluateRecordId, quotationType);
        })
    }

    componentWillReceiveProps(nextProps) {
        const { evaluateRecordId, quotationType } = nextProps;
        if (evaluateRecordId !== this.props.evaluateRecordId || quotationType !== this.props.quotationType) {
            this.setState({
                evaluateRecordId,
                quotationType,
            },() => {
                this.loadData(evaluateRecordId, quotationType);
            })
        }
    }

    loadData = (evaluateRecordId, quotationType) => {
        if(!evaluateRecordId) return
        const options = {
            method: 'POST',
            url: API_URL.evaluate.viewEvaluateRecordDifficulty,
            data: {
                evaluateRecordId,
                quotationType,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    params: (res.data || {}),
                    list: res.list ? res.list : [],
                });
            }
        };
        $.sendRequest(options);
    };

    submit = () => {
        const { params, evaluateRecordId, quotationType } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.updateEvaluateRecordDifficulty,
            data: {
                ...params,
                evaluateRecordId,
                quotationType,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    type: 'view',
                }, () => this.loadData( evaluateRecordId, quotationType ));
            }
        };
        $.sendRequest(options);
    }

    handleChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params: {...params} });
    }

    setWordWrap = (text) => {
        const arr = (text || "").split("\n");
        return (
            <div>
                {arr.map((el) => (
                    <span>
                        {el}
                        <br />
                    </span>
                ))}
            </div>
        );
    }

    render() {
        const { params, type, evaluateRecordId, quotationType, list } = this.state;
        const { showButn = true } = this.props;
        const {
            productQualityState,
            programmeQualityState,
            programmeInRowState,
            researchProcessCorrelation,
            contendProductExperimentState,
            otherRemark,
        } = params;
        return (
        <div className='analysis-form'>
            <div className='item'>
                <div className='left'>研发产品优劣情况：</div>
                <div className='right'>
                    {type === 'view' ? this.setWordWrap(productQualityState) : <TextArea rows={4} value={productQualityState} onChange={e => this.handleChange(e, 'productQualityState')}/>}
                </div>
            </div>
            <div className='item'>
                <div className='left'>治疗方案优劣情况：</div>
                <div className='right'>
                {type === 'view' ? this.setWordWrap(programmeQualityState) : <TextArea rows={4} value={programmeQualityState} onChange={e => this.handleChange(e, 'programmeQualityState')}/>}
                </div>
            </div>
            <div className='item'>
                <div className='left'>项目方案入排相关：</div>
                <div className='right'>
                {type === 'view' ? this.setWordWrap(programmeInRowState) : <TextArea rows={4} value={programmeInRowState} onChange={e => this.handleChange(e, 'programmeInRowState')}/>}
                </div>
            </div>
            <div className='item'>
                <div className='left'>研究流程相关：</div>
                <div className='right'>
                {type === 'view' ? this.setWordWrap(researchProcessCorrelation) : <TextArea rows={4} value={researchProcessCorrelation} onChange={e => this.handleChange(e, 'researchProcessCorrelation')}/>}
                </div>
            </div>
            <div className='item'>
                <div className='left'>竞争产品或竞争实验情况：</div>
                <div className='right'>
                {type === 'view' ? this.setWordWrap(contendProductExperimentState) : <TextArea rows={4} value={contendProductExperimentState} onChange={e => this.handleChange(e, 'contendProductExperimentState')}/>}
                </div>
            </div>
            <div className='item'>
                <div className='left'>其他备注说明：</div>
                <div className='right'>
                {type === 'view' ? this.setWordWrap(otherRemark) : <TextArea rows={4} value={otherRemark} onChange={e => this.handleChange(e, 'otherRemark')}/>}
                </div>
            </div>
            {
                !!list.length && list.map(el => {
                    const { canEdit, versionNum, versionRemark } = el;
                    return <div className='item'>
                        <div className='left'>{`${versionNum}版备注说明：`}</div>
                        <div className='right'>
                            {(type === 'edit' && canEdit) ? <TextArea rows={4} value={params.versionRemark} onChange={e => this.handleChange(e, 'versionRemark')}/> : this.setWordWrap(versionRemark)}
                        </div>
                    </div>
                })
            }
            { showButn && <div className='Forecast_Params_footer'>
                {
                    type === 'view'?
                    <Button 
                        type="primary"
                        onClick={() => this.setState({
                            type: 'edit',
                        })}
                    >编辑</Button> :
                    <div>
                        <Button 
                            style={{ marginRight: 20 }}
                            onClick={() => this.setState({
                                type: 'view',
                            }, () => this.loadData( evaluateRecordId, quotationType ))}
                        >取消</Button>
                        <Button 
                            type="primary"
                            onClick={this.submit}
                        >保存</Button>
                    </div>
                }
            </div>}
        </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/KeyAnalysis.js